"use client";

import { useEffect, useState } from "react";
import { estaAbierto, type Semana } from "@/lib/directorio/horario";

/**
 * El distintivo de "abierto ahora".
 *
 * Va en el navegador a proposito: estas paginas estan cacheadas una hora, asi
 * que si se calculara en el servidor diria la verdad como mucho una vez. En el
 * primer pintado no sale nada, y aparece en cuanto carga: mas vale nada que un
 * "abierto" falso.
 *
 * Los textos llegan ya traducidos desde el servidor: este componente no sabe de
 * idiomas y asi no arrastra el diccionario entero al navegador.
 */
export function AbiertoAhora({
  semana,
  abierto: textoAbierto,
  cerrado: textoCerrado,
}: {
  semana: Semana;
  abierto: string;
  cerrado: string;
}) {
  const [abierto, setAbierto] = useState<boolean | null>(null);

  useEffect(() => {
    const mirar = () => setAbierto(estaAbierto(semana, new Date()));
    mirar();
    const reloj = setInterval(mirar, 60_000);
    return () => clearInterval(reloj);
  }, [semana]);

  if (abierto === null) return null;

  return (
    <span
      className={
        abierto
          ? "inline-flex items-center gap-1.5 rounded-md bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700"
          : "inline-flex items-center gap-1.5 rounded-md bg-zinc-100 px-2 py-0.5 text-xs font-medium text-zinc-500"
      }
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${abierto ? "bg-emerald-500" : "bg-zinc-400"}`}
        aria-hidden
      />
      {abierto ? textoAbierto : textoCerrado}
    </span>
  );
}
